export const programSearchSiteCoreKeys = {
  header: "SearchProgramAndCandidateHeader",
  headerCreateProgram: "SearchProgramAndCandidateHeader.CreateProgram",
  headerCreateNISParticipant:
    "SearchProgramAndCandidateHeader.CreateNewNISParticipantButton",
  addBulkActivityButton:
    "SearchProgramAndCandidateHeader.AddBulkActivityButton",
  tabNip3Candidate: "SearchProgramAndCandidateHeader.NIP3CandidatesTab",
  searchFormKey: "SearchProgramAndCandidateSearch",
  tabProgram: "SearchProgramAndCandidateHeader.ProgramsTab",
  searchHeader: "SearchProgramAndCandidateSearch",
  individuaRadio: "SearchProgramAndCandidateSearch.FilterByList",
  searchFilterByList: "SearchProgramAndCandidateSearch.FilterByList",
  statusList: "SearchProgramAndCandidateSearch.ProgramStatusList",
  individuals: "SearchProgramAndCandidateSearch.Individuals",
  programs: "SearchProgramAndCandidateSearch.Programs",
  selectSearchTypeLabel: "SearchProgramAndCandidateSearch.SelectSearchType",
  programStatusLabel: "SearchProgramAndCandidateSearch.ProgramStatus",
  programStartMonthOrYearLabel:
    "SearchProgramAndCandidateSearch.ProgramStartMonthOrYear",
  ProgramNameLabel: "SearchProgramAndCandidateSearch.ProgramName",
  showLess: "Common.ShowLess",
  showMore: "Common.ShowMore",
  solutionCategoryLabel: "SearchProgramAndCandidateSearch.SolutionCategory",
  billingContactLastNameLabel:
    "SearchProgramAndCandidateSearch.BillingContactLastName",
  hRContactLastNameLabel: "SearchProgramAndCandidateSearch.HRContactLastName",
  projectManagerLabel: "SearchProgramAndCandidateSearch.ProjectManager",
  productLineLabel: "SearchProgramAndCandidateSearch.ProductLine",
  clientRelationshipOwnerLabel:
    "SearchProgramAndCandidateSearch.ClientRelationshipOwner",
  localClientRelationshipOwner:
    "SearchProgramAndCandidateSearch.LocalClientRelationshipOwner",
  projectKey: "SearchProgramAndCandidateSearch.ProjectKey",
  projectName: "SearchProgramAndCandidateSearch.ProjectName",
  resultFormKey: "SearchProgramAndCandidateResults",
  projectKeyLabel: "SearchProgramAndCandidateResults.ProjectKey",
  projectNameLabel: "SearchProgramAndCandidateResults.ProjectName",
  actionLabel: "SearchProgramAndCandidateResults.Action",
  programKeyLabel: "SearchProgramAndCandidateResults.ProgramKey",
  programNameLabel: "SearchProgramAndCandidateResults.ProgramName",
  companyNameLabel: "SearchProgramAndCandidateResults.ClientName",
  programTemplateNameLabel:
    "SearchProgramAndCandidateResults.ProgramTemplateName",
  programStatusResult: "SearchProgramAndCandidateResults.ProgramStatus",
  countryLabel: "SearchProgramAndCandidateResults.Country",
  programStatusList: "SearchProgramAndCandidateSearch.ProgramStatusList",
  clientManagedStatusList:
    "SearchProgramAndCandidateSearch.ClientManagedStatusList",
  eligibilityList:
    "ProgramsAndCandidates.SearchProgramAndCandidateResults.EligibilityList",
  participantNameLabel: "SearchProgramAndCandidateResults.ParticipantName",
  participantTypeLabel: "SearchProgramAndCandidateResults.ParticipantType",
  clientManagedStatusLabel:
    "SearchProgramAndCandidateResults.ClientManagedStatus",
  localClientRelationshipOwnerLabel:
    "SearchProgramAndCandidateResults.LocalClientRelationshipOwner",
  participantEmailLabel: "SearchProgramAndCandidateResults.ParticipantEmail",
  participantMobileNumberLabel:
    "SearchProgramAndCandidateResults.ParticipantMobileNumber",
  transferParticipantOption:
    "SearchProgramAndCandidateResults.TransferParticipantOption",
  p3ParticipantEmailPrimary:
    "SearchProgramAndCandidateSearch.P3ParticipantEmail-Primary",
  p3ParticipantEmailAlternate:
    "SearchProgramAndCandidateSearch.P3ParticipantEmail-Alternate",
  p3ParticipantMobileNumberPrimary:
    "SearchProgramAndCandidateSearch.P3ParticipantMobileNumber-Primary",
  p3ParticipantMobileNumberAlternate:
    "SearchProgramAndCandidateSearch.P3ParticipantMobileNumber-Alternate",
  nextParticipantEmailPrimary:
    "SearchProgramAndCandidateSearch.NEXTParticipantEmail-Primary",
  nextParticipantEmailAlternate:
    "SearchProgramAndCandidateSearch.NEXTParticipantEmail-Alternate",
  participantFirstName: "SearchProgramAndCandidateSearch.ParticipantFirstName",
  participantLastName: "SearchProgramAndCandidateSearch.ParticipantLastName",
  participantMobileNumber:
    "SearchProgramAndCandidateSearch.ParticipantMobileNumber",
  clientManagedStatus: "SearchProgramAndCandidateSearch.ClientManagedStatus",
  programKey: "SearchProgramAndCandidateSearch.ProgramKey",
  clientName: "SearchProgramAndCandidateSearch.ClientName",
  monthPlaceholder: "SearchProgramAndCandidateSearch.Month",
  yearPlaceholder: "SearchProgramAndCandidateSearch.Year",
  transferParticipantPopup:
    "ProgramsAndCandidates.TransferParticipant.TransferParticipantPopup",
  nextLanguage: "TransferParticipant.TransferParticipantPopup.NEXTLanguage",
  changeCountry:
    "TransferParticipant.TransferParticipantPopup.ChangeCountryRadioButton",
  changeProgram:
    "TransferParticipant.TransferParticipantPopup.ChangeProgramRadioButton",
  compatibleProgramTemplate:
    "TransferParticipant.TransferParticipantPopup.CompatibleProgramTemplate",
  destinationCountry:
    "TransferParticipant.TransferParticipantPopup.DestinationCountry",
  nextView:
    "TransferParticipant.TransferParticipantPopup.DestinationProgramNextView",
  destinationProgram:
    "TransferParticipant.TransferParticipantPopup.DestinationProgramSection",
  programKeyInputTransfer:
    "TransferParticipant.TransferParticipantPopup.ProgramKey",
  participantDetails:
    "TransferParticipant.TransferParticipantPopup.ParticipantDetailsSection",
  participantName:
    "TransferParticipant.TransferParticipantPopup.ParticipantName",
  proceed: "TransferParticipant.TransferParticipantPopup.ProceedTransferButton",
  programStatus: "TransferParticipant.TransferParticipantPopup.ProgramStatus",
  programTemplate:
    "TransferParticipant.TransferParticipantPopup.ProgramTemplate",
  sourceProgram:
    "TransferParticipant.TransferParticipantPopup.SourceProgramSection",
  transferType:
    "TransferParticipant.TransferParticipantPopup.TransferTypeSection",
  sourceCountry: "TransferParticipant.TransferParticipantPopup.SourceCountry",
  supportTicket:
    "TransferParticipant.TransferParticipantPopup.SubmitSupportTicket",
  processUpdate:
    "TransferParticipant.TransferParticipantPopup.TransferInformationPopup",
  bulkEditProgram:
    "SearchProgramAndCandidateHeader.BulkCreateProgramButton_BulkEditProgram",
  bulkInsertActivity:
    "SearchProgramAndCandidateHeader.BulkCreateProgramButton_BulkInsertActivity",
  bulkTransferParticipants:
    "SearchProgramAndCandidateHeader.BulkCreateProgramButton_BulkTransferParticipants",
  bulkCreateProgramButton:
    "SearchProgramAndCandidateHeader.BulkCreateProgramButton",
  allRadioButton: "SearchProgramAndCandidateSearch.AllRadioButton",
  genericParticipantsRadioButton:
    "SearchProgramAndCandidateSearch.GenericParticipantsRadioButton",
  genericAccountName: "SearchProgramAndCandidateSearch.GenericAccountName",
  genericRegistrationCode:
    "SearchProgramAndCandidateSearch.GenericRegistrationCode",
  emailIdLabel: "SearchProgramAndCandidateSearch.EmailID",
  clientLabel: "SearchProgramAndCandidateSearch.Client",
  nextViewLabel: "SearchProgramAndCandidateSearch.NextView",
  genericAccountStatus: "SearchProgramAndCandidateSearch.GenericAccountStatus",
  genericAccountStatusList:
    "SearchProgramAndCandidateSearch.GenericAccountStatusList",
  nextProgramClass: "SearchProgramAndCandidateSearch.NextProgramClass",
  participantStatus: "SearchProgramAndCandidateSearch.ParticipantStatus",
  participantStatusList:
    "SearchProgramAndCandidateSearch.ParticipantStatusList",
  purposeLabel: "SearchProgramAndCandidateSearch.Purpose",
  purposeList: "SearchProgramAndCandidateSearch.PurposeList",
  countrySearchLabel: "SearchProgramAndCandidateSearch.Country",
  deliveryOffices: "SearchProgramAndCandidateSearch.DeliveryOffices",
  requestedBy: "SearchProgramAndCandidateSearch.RequestedBy",
  emailIdColumnHeader: "SearchProgramAndCandidateResults.EmailID",
  programEndDate: "SearchProgramAndCandidateResults.ProgramEndDate",
  participantStatusHeader: "SearchProgramAndCandidateResults.ParticipantStatus",
  deliveryOfficeHeader: "SearchProgramAndCandidateResults.DeliveryOffice",
  // nis search
  nisParticipants: "SearchProgramAndCandidateSearch.NISParticipantsRadioButton",
  clientEmployer: "SearchProgramAndCandidateSearch.Client-Employer",
  nisId: "SearchProgramAndCandidateSearch.NISID",
  nisStatus: "SearchProgramAndCandidateSearch.NISStatus",
  nisStatusList: "SearchProgramAndCandidateSearch.NISStatusList",
  participantEmailPersonal:
    "SearchProgramAndCandidateSearch.ParticipantEmail-Personal",
  participantEmailWork: "SearchProgramAndCandidateSearch.ParticipantEmail-Work",
  hrContact: "SearchProgramAndCandidateSearch.HRContact",
  // nis result
  productLineTableColumn: "SearchProgramAndCandidateResults.ProductLine",
  participantStatusTableColumn:
    "SearchProgramAndCandidateResults.ParticipantStatus",
  projectManagerTableColumn: "SearchProgramAndCandidateResults.ProjectManager",
  solutionCategoryTableColumn:
    "SearchProgramAndCandidateResults.SolutionCategory",
  programStartMonthOrYearTableColumn:
    "SearchProgramAndCandidateResults.ProgramStartMonthOrYear",
  clientManagedStatusListResult:
    "SearchProgramAndCandidateResults.ClientManagedStatusList",
  billingContact: "SearchProgramAndCandidateResults.BillingContact",
  clientEmployerTableColumn: "SearchProgramAndCandidateResults.Client-Employer",
  programTemplateTableColumn:
    "SearchProgramAndCandidateResults.ProgramTemplate",
  keyNISNumber: "SearchProgramAndCandidateResults.Key-NISNumber",
  hrContactTableColumn: "SearchProgramAndCandidateResults.HRContact",
  candidateTypeList: "SearchProgramAndCandidateResults.CandidateTypeList",
  nisParticipantStatusList:
    "ProgramsAndCandidates.SearchProgramAndCandidateResults.NISParticipantStatusList",
  convertToProgramAction:
    "SearchProgramAndCandidateResults.ConvertToProgramAction",
  convertToProgramConfirmationMessage:
    "SearchProgramAndCandidateResults.ConvertToProgramConfirmationMessage",
};

export const transferProgramDetailsSiteCoreKeys = {
  transferDetailsKey:
    "ProgramsAndCandidates.ParticipantTransfer.TransferDetails",
  sourceProgram: "ParticipantTransfer.TransferDetails.Source-SourceProgram",
  sourceCountry: "ParticipantTransfer.TransferDetails.Source-SourceCountry",
  programTemplate: "ParticipantTransfer.TransferDetails.Source-ProgramTemplate",
  nextView: "ParticipantTransfer.TransferDetails.Source-NextView",
  destinationProgram:
    "ParticipantTransfer.TransferDetails.Destination-DestinationProgram",
  destinationCountry:
    "ParticipantTransfer.TransferDetails.Destination-DestinationCountry",
  compatibleProgramTemplate:
    "ParticipantTransfer.TransferDetails.Destination-CompatibleProgramTemplate",
  noTemplateAvailable:
    "ParticipantTransfer.TransferDetails.NoTemplateAvailable",
  deliveryOffice: "ParticipantTransfer.TransferDetails.DeliveryOffice",
  nextLanguage: "ParticipantTransfer.TransferDetails.NEXTLanguage",
};
